import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', path: '/' },
  { label: '分类', path: '/category/system-tools' },
  { label: '文章', path: '/article/latest-version-4-2-0-release' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 group">
          <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
            <span className="text-background-50 font-bold text-sm font-label">91</span>
          </div>
          <span className={`font-heading font-bold text-lg transition-colors duration-300 ${
            scrolled ? 'text-foreground-900' : 'text-background-50'
          }`}>
            91免费版
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path || 
              (item.path.startsWith('/category') && location.pathname.startsWith('/category')) ||
              (item.path.startsWith('/article') && location.pathname.startsWith('/article'));
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  isActive
                    ? scrolled
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-white/20 text-background-50'
                    : scrolled
                      ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                      : 'text-background-50/80 hover:text-background-50 hover:bg-white/10'
                }`}
              >
                {item.label}
              </Link>
            );
          })}
          <a
            href="#download"
            className="ml-3 px-5 py-2 bg-primary-500 text-background-50 rounded-lg text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            免费下载
          </a>
        </div>

        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
            scrolled ? 'text-foreground-900' : 'text-background-50'
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                    isActive
                      ? 'bg-primary-50 text-primary-700'
                      : 'text-foreground-600 hover:bg-background-100'
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
            <a
              href="#download"
              className="mt-2 px-4 py-3 bg-primary-500 text-background-50 rounded-lg text-sm font-semibold text-center whitespace-nowrap cursor-pointer"
            >
              免费下载
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}